import React, { Fragment } from 'react';
import { Dialog } from '@material-ui/core';
import PropTypes from 'prop-types';
import InfoLarge from '../../Analytics/assets/DisclaimerWarning1.svg';
import { getStaticText } from '../../../utils/constants';

const WarningDialog = ({ setView, defaultSettings }) => {
    const { lang: defaultlang } = defaultSettings;
    const staticText = getStaticText(defaultlang);
    const { SITE_TEXT } = staticText;
    const { EX_DIALOG_TXT_1, EX_DIALOG_TXT_2, DISCLAIMER, CONTINUE } = SITE_TEXT;
    return (
        <Dialog
            open
            disableEscapeKeyDown
            disableBackdropClick
            maxWidth="md"
            classes={{
                root: 'feedbackSuccessDialogRoot warningDialogRoot',
            }}
        >
            <section className="dataContent dataHead">
                <div className="infoLarge bmxInfoWarn">
                    <img src={InfoLarge} alt="" />
                </div>
                <h2>{DISCLAIMER}!</h2>
                {/* <div className="nRes">
                    {'Jira ticket ID : '} <b>{jira_number}</b>
                </div> */}
                <div className="para">
                    <div>{EX_DIALOG_TXT_1}</div>
                    <div> {EX_DIALOG_TXT_2} </div>
                </div>
            </section>

            <section className="buttonContent clearfix activeButtons">
                <Fragment>
                    <div
                        data-testid="compareButton"
                        className="compareBtn activeCompareBtn"
                        onClick={() => {
                            setView(false);
                        }}
                    >
                        {CONTINUE}
                    </div>
                </Fragment>
            </section>
        </Dialog>
    );
};

WarningDialog.propTypes = {
    setView: PropTypes.func.isRequired,
    defaultSettings: PropTypes.object.isRequired,
};

export default WarningDialog;
